<div class="chart-card">
  <div class="cc-head">
    <div class="chart-figure">
      <span class="live"><span class="live-dot" aria-hidden="true"></span>قیمت لحظه‌ای · هر گرم طلای آب‌شدهٔ ۷۵۰</span>
      <div class="cf-value">{{ buyLabel() }} <span class="unit">ریال</span></div>
      <div class="cf-sub">
        فروش: {{ sellLabel() }} ریال
        @if (dateLabel()) {
          · {{ dateLabel() }}
        }
      </div>
    </div>
    <div class="chart-tabs" role="group" aria-label="بازه‌ی نمودار">
      @for (r of ranges; track r.days) {
        <button type="button" [class.active]="range() === r.days" [attr.aria-pressed]="range() === r.days"
                [attr.aria-label]="r.title" (click)="select(r.days)">{{ r.label }}</button>
      }
    </div>
  </div>

  <div class="chart-plot" [class.is-loading]="loading()">
    <div class="chart-wrap">
      <svg viewBox="0 0 720 320" preserveAspectRatio="none" role="img" [attr.aria-label]="chartLabel()"
           (pointermove)="track($event)" (pointerleave)="untrack()">
        <defs>
          <linearGradient id="garea" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" style="stop-color:var(--gold-500);stop-opacity:0.32"/>
            <stop offset="100%" style="stop-color:var(--gold-500);stop-opacity:0"/>
          </linearGradient>
          <linearGradient id="gline" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" style="stop-color:var(--gold-700)"/>
            <stop offset="100%" style="stop-color:var(--gold-400)"/>
          </linearGradient>
        </defs>
        @for (y of gridYs; track $index) {
          <line [attr.x1]="gridX1" [attr.x2]="gridX2" [attr.y1]="y" [attr.y2]="y" class="grid" stroke-width="1"/>
        }
        @for (g of drawn(); track g.key) {
          <path [attr.d]="g.area" fill="url(#garea)"/>
          <path class="cline" [attr.d]="g.line" pathLength="1" fill="none" stroke="url(#gline)" stroke-width="2.4"
                stroke-linecap="round" stroke-linejoin="round"/>
          <circle [attr.cx]="g.end.x" [attr.cy]="g.end.y" r="4.5" class="end-dot"/>
          <circle [attr.cx]="g.end.x" [attr.cy]="g.end.y" r="8" class="end-dot" opacity="0.18"/>
        }
        @if (hover(); as h) {
          <line class="cross" [attr.x1]="h.x" [attr.x2]="h.x" [attr.y1]="gridYs[0]" [attr.y2]="gridYs[4]"
                stroke-width="1" stroke-dasharray="3 3"/>
          <circle class="chov" [attr.cx]="h.x" [attr.cy]="h.y" r="4" stroke-width="2"/>
        }
      </svg>
      @if (hover(); as h) {
        @if (tip(); as t) {
          <div class="chart-tip" [class.at-start]="t.edge === 'start'" [class.at-end]="t.edge === 'end'"
               [style.left.px]="t.left" [style.top.px]="t.top">
            <b>{{ h.price }} ریال</b><small>{{ h.when }}</small>
          </div>
        }
      }
    </div>
    <div class="chart-axis" aria-hidden="true">
      @for (label of axis(); track $index) {
        <span>{{ label }}</span>
      }
    </div>
  </div>

  <div class="chart-stats">
    <div class="cs">
      <b class="chg" [class.up]="change()?.up === true" [class.down]="change()?.up === false">{{ change()?.label ?? '—' }}</b>
      <span>تغییرات امروز</span>
    </div>
    <div class="cs">
      <b>{{ highLabel() }} <i>ریال</i></b>
      <span>بالاترین قیمت</span>
    </div>
    <div class="cs">
      <b>{{ lowLabel() }} <i>ریال</i></b>
      <span>پایین‌ترین قیمت</span>
    </div>
  </div>
</div>
